import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

import { useUser } from '@/composables/auth/useUser'
import AdminDashboardView from './AdminDashboardView.vue'
import EmployeeDashboardView from './EmployeeDashboardView.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'DashboardView',
  setup(__props) {

const { userType } = useUser()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_unref(userType) === 'Admin')
      ? (_openBlock(), _createBlock(AdminDashboardView, { key: 0 }))
      : (_openBlock(), _createBlock(EmployeeDashboardView, { key: 1 }))
  ]))
}
}

})